export default "__VITE_ASSET__Ct0x8nch__"